import type { PublicRouteClassifierContribution } from '#kernel/public-site/public-route-classifier-types.ts';

export default {
  id: 'dynamic-google-ads-campaigns',
  paths: ['/l/:slug'],
} as const satisfies PublicRouteClassifierContribution;
